const routes = [
  // {
  //   path: "/activityManage",
  //   name: authCodeMap.activityManage,
  //   component: (): any => import("@/modules/router.vue"),
  //   meta: {
  //     title: "活动管理",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.activityManage,
  //   },
  //   children: [
  //     {
  //       path: authCodeMap.activityManage_newDoctorActivityManage_analyseList,
  //       name: authCodeMap.activityManage_newDoctorActivityManage_analyseList,
  //       component: (): any => import("@/modules/activityManage/pages/newDoctorActivityManage/analyseList.vue"),
  //       meta: {
  //         title: "学术活动_病例分析_首页",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_newDoctorActivityManage_analyseList,
  //       },
  //     },
  //     {
  //       path: authCodeMap.activityManage_newDoctorActivityManage_manageList,
  //       name: authCodeMap.activityManage_newDoctorActivityManage_manageList,
  //       component: (): any => import("@/modules/activityManage/pages/newDoctorActivityManage/activityManageList.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_newDoctorActivityManage_manageList,
  //       },
  //     },
  //     {
  //       path: authCodeMap.activityManage_newDoctorActivityManage_edit,
  //       name: authCodeMap.activityManage_newDoctorActivityManage_edit,
  //       component: (): any => import("@/modules/activityManage/pages/newDoctorActivityManage/edit.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_newDoctorActivityManage_edit,
  //       },
  //     },
  //     {
  //       path: authCodeMap.activityManage_newDoctorActivityManage_detail,
  //       name: authCodeMap.activityManage_newDoctorActivityManage_detail,
  //       component: (): any => import("@/modules/activityManage/pages/newDoctorActivityManage/activityDetail.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_newDoctorActivityManage_detail,
  //       },
  //     },
  //     {
  //       path: authCodeMap.activityManage_newDoctorActivityManage_list,
  //       name: authCodeMap.activityManage_newDoctorActivityManage_list,
  //       component: (): any => import("@/modules/activityManage/pages/newDoctorActivityManage/activityList.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_newDoctorActivityManage_list,
  //       },
  //     },
  //     //////////////////////////////////////////////////////////////////////
  //     {
  //       path: authCodeMap.activityManage_doctorActivityManage_manageList,
  //       name: authCodeMap.activityManage_doctorActivityManage_manageList,
  //       component: (): any => import("@/modules/activityManage/pages/doctorActivityManage/activityManageList.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_doctorActivityManage_manageList,
  //       },
  //     },
  //     {
  //       path: authCodeMap.activityManage_doctorActivityManage_edit,
  //       name: authCodeMap.activityManage_doctorActivityManage_edit,
  //       component: (): any => import("@/modules/activityManage/pages/doctorActivityManage/edit.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_doctorActivityManage_edit,
  //       },
  //     },
  //     {
  //       path: authCodeMap.activityManage_doctorActivityManage_detail,
  //       name: authCodeMap.activityManage_doctorActivityManage_detail,
  //       component: (): any => import("@/modules/activityManage/pages/doctorActivityManage/activityDetail.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_doctorActivityManage_detail,
  //       },
  //     },
  //     {
  //       path: authCodeMap.activityManage_doctorActivityManage_list,
  //       name: authCodeMap.activityManage_doctorActivityManage_list,
  //       component: (): any => import("@/modules/activityManage/pages/doctorActivityManage/activityList.vue"),
  //       meta: {
  //         title: "运营_邀约管理_活动邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_doctorActivityManage_list,
  //       },
  //     },
  //     {
  //       path: "contentInvite",
  //       name: authCodeMap.activityManage_contentInvite,
  //       component: (): any => import("@/modules/activityManage/pages/contentInvite/index.vue"),
  //       meta: {
  //         title: "运营_邀约管理_内容邀约",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_contentInvite,
  //       },
  //     },
  //     {
  //       path: "contentInviteDetail",
  //       name: authCodeMap.activityManage_invite_detail,
  //       component: (): any => import("@/modules/activityManage/pages/qsInvite/components/inviteDetails/index.vue"),
  //       meta: {
  //         title: "运营_邀约管理_内容邀约_邀约详情",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_invite_detail,
  //       },
  //     },
  //     {
  //       path: "contentInviteEdit",
  //       name: authCodeMap.activityManage_invite_add,
  //       component: (): any => import("@/modules/activityManage/pages/contentInvite/edit.vue"),
  //       meta: {
  //         title: "运营_邀约管理_内容邀约_编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_invite_add,
  //       },
  //     },
  //     {
  //       path: "gradeManagement",
  //       name: authCodeMap.grade_management,
  //       component: (): any => import("@/modules/activityManage/pages/gradeManagement/index.vue"),
  //       meta: {
  //         title: "运营_等级管理",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.grade_management,
  //       },
  //     },
  //     {
  //       path: "cityBudget",
  //       name: authCodeMap.city_budget,
  //       component: (): any => import("@/modules/activityManage/pages/cityBudget/index.vue"),
  //       meta: {
  //         title: "运营_城市预算",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.city_budget,
  //       },
  //     },
  //     {
  //       path: "cityBudgetEdit",
  //       name: authCodeMap.city_budget_add,
  //       component: (): any => import("@/modules/activityManage/pages/cityBudget/edit.vue"),
  //       meta: {
  //         title: "运营_城市预算_编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.city_budget_add,
  //       },
  //     },
  //     {
  //       path: "cityBudgetDetail",
  //       name: authCodeMap.city_budget_detail,
  //       component: (): any => import("@/modules/activityManage/pages/cityBudget/detail.vue"),
  //       meta: {
  //         title: "运营_城市预算_编辑",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.city_budget_detail,
  //       },
  //     },
  //     {
  //       path: "qsInvite",
  //       name: authCodeMap.activityManage_qsInvite,
  //       component: () => import("@/modules/activityManage/pages/qsInvite/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "运营_邀约管理_问答邀约",
  //       },
  //     },
  //     {
  //       name: authCodeMap.activityManage_invite_detail,
  //       path: "inviteDetails",
  //       component: () => import("@/modules/activityManage/pages/qsInvite/components/inviteDetails/index.vue"),
  //       meta: {
  //         needLogin: true,
  //         title: "运营_邀约管理_问答邀约_邀约详情",
  //       },
  //     },
  //     {
  //       path: "landingPage",
  //       name: authCodeMap.activityManage_landingPage,
  //       component: (): any => import("@/modules/activityManage/pages/landingPage/index.vue"),
  //       meta: {
  //         title: "营销_营销落地页",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_landingPage,
  //       },
  //     },
  //     {
  //       path: "landingPageEdit",
  //       name: authCodeMap.activityManage_landingPage_add,
  //       component: (): any => import("@/modules/activityManage/pages/landingPage/edit.vue"),
  //       meta: {
  //         title: "营销_营销落地页_新建落地页",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_landingPage_add,
  //       },
  //     },
  //     {
  //       path: "landingPageGuide",
  //       name: authCodeMap.activityManage_landingPage_guide,
  //       component: (): any => import("@/modules/activityManage/pages/landingPage/guide.vue"),
  //       meta: {
  //         title: "营销_营销落地页_帮助文档",
  //         hidden: true,
  //         needLogin: true,
  //         authCode: authCodeMap.activityManage_landingPage_guide,
  //       },
  //     },
  //   ],
  // },
];
export default routes;